import React from 'react';
import {
  SitemapCollection as SitemapCollectionType,
  SitemapItems,
} from '../../../../types';
import SitemapItem from '../sitemap-item';
import * as S from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = Pick<SitemapCollectionType, 'sitemapItems'>;

const SitemapCollection = ({ sitemapItems }: Props) => {
  return (
    <S.SitemapItemList>
      {Array.isArray(sitemapItems) &&
        sitemapItems
          .filter((obj): obj is SitemapItems => obj !== undefined)
          .map(({ path, title }, index) => (
            <SitemapItem
              key={path}
              path={path}
              title={title}
              onClick={() =>
                trackInternalNavigationClick({
                  scope:
                    InternalNavigationScope.PRODUCT_COLLECTION_SITEMAP_LINK,
                  nextPage: path,
                  index,
                })
              }
            />
          ))}
    </S.SitemapItemList>
  );
};

export default SitemapCollection;
